const comments = [
  {
    id: 1,
    avatar: 'R',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这网站真的绝了，每天上班第一件事就是刷吃瓜爆料网，比微博热搜还快！昨天那个顶流塌房的料，我在这先看到的。',
    likes: 328,
  },
  {
    id: 2,
    avatar: '暖',
    name: '暖暖小太阳',
    time: '5小时前',
    content: '作为一个资深吃瓜人，这个站的信息整合能力真的强，各个平台的料都能第一时间汇总，省得我到处找了。',
    likes: 256,
  },
  {
    id: 3,
    avatar: '夜',
    name: '夜空中最亮的瓜',
    time: '8小时前',
    content: '爆料更新速度也太快了吧，下午刚出来的瓜晚上就已经有深度分析了。小编团队是真的在认真做内容。',
    likes: 189,
  },
  {
    id: 4,
    avatar: '风',
    name: '风中一匹狼',
    time: '12小时前',
    content: '说实话现在能这么稳定更新的爆料站不多了，而且没有乱七八糟的广告弹窗，体验感拉满。已推荐给所有同事。',
    likes: 145,
  },
  {
    id: 5,
    avatar: '星',
    name: '星光不负赶路人',
    time: '1天前',
    content: '刚发现这个宝藏网站！评论区也很有料，好多课代表整理时间线，吃瓜体验比在微博刷屏好太多了。',
    likes: 97,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">网友热评</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">真实吃瓜用户的走心评价，口碑见证我们的实力</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {comments.map((c) => (
            <div
              key={c.id}
              className="bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-accent-300/50 transition-colors duration-200"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-200 text-accent-700 font-heading text-lg flex items-center justify-center flex-shrink-0">
                  {c.avatar}
                </div>
                <div className="min-w-0">
                  <div className="font-medium text-sm text-foreground-900 truncate">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3 line-clamp-4">
                {c.content}
              </p>
              <div className="flex items-center gap-1 text-foreground-400 text-xs">
                <i className="ri-thumb-up-line"></i>
                <span>{c.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}